import React, { Component } from "react";
import { Menu } from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Aux from "../utility/Aux";
import FileMenuItem from "./FileMenuItem";
import {
  selectDocument,
  closeDocumentInTaskList
} from "../../actions/tasklist";

/**
 * TaskList : Component
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Task list component that displays currently open tasks/documents
 * as tabs, allowing the user to quickly switch the current document
 * within the selected context.
 */
class TaskList extends Component {
  /**
   * handleItemClick: (event, sender) => ()
   * Fires when the user has clicked a specific task item
   */
  handleItemClick = (e, { name }) => {
    if (/\bclose/.test(e.target.className)) {
      return;
    }
    this.props.selectDocument(name, this.props.currentContext);
    this.props.history.push("/document");
  };

  /**
   * closeItem = documentIdentifier => ()
   * Closes an item from the task list with the specified
   * document identifier
   */
  closeItem = documentIdentifier => {
    this.props.closeDocumentInTaskList(
      documentIdentifier,
      this.props.currentContext
    );
  };

  /**
   * render: ()
   * Renders the task list component conditionally.
   */
  render() {
    const { currentContext, files, tasklist } = this.props;
    /**
     * The task list will be empty if no context
     * is currently open.
     */
    if (!currentContext) {
      return null;
    }
    if (
      !tasklist.hasOwnProperty(currentContext) ||
      !files.hasOwnProperty(currentContext)
    ) {
      return null;
    }

    /**
     * Filter the files in the current context to only
     * include the ones currently open in the tasklist
     */
    const open = files[currentContext].filter(
      file => tasklist[currentContext].indexOf(file.id) !== -1
    );

    return (
      <Aux inline>
        <Menu secondary pointing>
          {open.map(document => (
            <FileMenuItem
              key={document.id}
              document={document}
              onClick={this.handleItemClick}
              currentApplication={this.props.currentApplication}
              currentDocument={this.props.currentDocument}
              hasCloseButton
              onClose={() => this.closeItem(document.id)}
            />
          ))}
        </Menu>
      </Aux>
    );
  }
}

TaskList.propTypes = {
  /**
   * currentContext: String
   * Context identifier for the currently selected context
   */
  currentContext: PropTypes.string,
  /**
   * currentDocument: String
   * Document identifier for the currently selected document
   */
  currentDocument: PropTypes.string,
  /**
   * currentApplication: String
   * Application URL of the currently open application
   */
  currentApplication: PropTypes.string.isRequired,
  /**
   * files: Object
   * Contains lists of currently loaded files ordered by context
   */
  files: PropTypes.shape({}).isRequired,
  /**
   * tasklist: Object
   * Contains currently open documents in the task list ordered
   * by context
   */
  tasklist: PropTypes.shape({}).isRequired,
  /**
   * selectDocument: (document, context) => ()
   * Action to dispatch document selection
   */
  selectDocument: PropTypes.func.isRequired,
  /**
   * closeDocumentInTaskList: (document, context) => ()
   * Action to close a document and remove it from the tasklist
   */
  closeDocumentInTaskList: PropTypes.func.isRequired,
  /**
   * History object connected through withRouter
   */
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired
};

TaskList.defaultProps = {
  currentContext: null,
  currentDocument: null
};

const mapStateToProps = state => ({
  /**
   * Make a deep copy of the state object, instead of
   * shallow, using JSON.parse(JSON.stringify(object))
   */
  tasklist: JSON.parse(JSON.stringify(state.tasklist.tasklist || {}))
});

export default connect(
  mapStateToProps,
  { selectDocument, closeDocumentInTaskList }
)(withRouter(TaskList));



// WEBPACK FOOTER //
// ./src/components/contextbar/TaskList.js